export default "__VITE_ASSET__BvgnIZjg__"